import definition from './auth-users.service';

/**
 * AuthUsersApi settings
 * @type {{name: string, definition: AuthUsersApi}}
 */
export default {
    name: 'AuthUsersApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/auth-users/index.js